const PRIORITY_COUNTRIES = [
  'Australia',
  'New Zealand',
  'Canada',
  'United States',
  'Singapore',
  'United Kingdom',
] as const

export const COUNTRY_OPTIONS = (() => {
  try {
    const DisplayNamesCtor = (Intl as typeof Intl & { DisplayNames?: typeof Intl.DisplayNames }).DisplayNames
    if (!DisplayNamesCtor) return [...PRIORITY_COUNTRIES]

    const displayNames = new DisplayNamesCtor(['en'], { type: 'region' })
    const intlWithSupportedValues = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }
    const regionCodes = intlWithSupportedValues.supportedValuesOf?.('region') ?? []
    const blockedCodes = new Set(['EU', 'EZ', 'UN', 'XA', 'XB', 'XK'])
    const regionNames = regionCodes
      .filter((code) => code.length === 2 && !blockedCodes.has(code))
      .map((code) => displayNames.of(code))
      .filter((name): name is string => !!name)

    const sortedCountries: string[] = Array.from(new Set([...PRIORITY_COUNTRIES, ...regionNames])).sort((a, b) =>
      a.localeCompare(b)
    )
    return sortedCountries.includes('Other') ? sortedCountries : [...sortedCountries, 'Other']
  } catch {
    const fallbackCountries: string[] = [...PRIORITY_COUNTRIES].sort((a, b) => a.localeCompare(b))
    return fallbackCountries.includes('Other') ? fallbackCountries : [...fallbackCountries, 'Other']
  }
})()
